module.exports = __webpack_public_path__ + "img/tickify.2834f50e.png";